import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1, 0),
    },
  })
);

interface SelectOptionsType {
  value: string | number;
  label: string;
}

interface SelectFieldProps {
  input: object;
  meta: { touched: boolean; error: boolean };
  options: SelectOptionsType[];
  label: string;
  name: string;
  helperText?: string;
  id?: string;
  readOnly?: boolean;
  fullWidth?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
}

const SelectField = ({
  input,
  label,
  meta: { touched, error },
  options,
  name,
  id,
  fullWidth,
  helperText,
  readOnly,
  variant,
  ...custom
}: SelectFieldProps) => {
  const classes = useStyles();
  return (
    <FormControl
      fullWidth={fullWidth}
      variant={variant}
      error={touched && error}
      className={classes.formControl}
    >
      <InputLabel
        htmlFor={id}
        style={
          variant === 'outlined'
            ? {
                background: 'white',
                padding: '0 .25rem',
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        inputProps={{
          name,
          id,
          readOnly,
        }}
        {...input}
        {...custom}
      >
        <MenuItem value="" disabled />
        {options.map(({ value, label }: SelectOptionsType) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      {error && <FormHelperText>{touched && error}</FormHelperText>}
    </FormControl>
  );
};

export default SelectField;
